import {Injectable} from '@angular/core';
import {Credentials} from '@app/core/credentials/domain/credentials';
import {firstValueFrom} from 'rxjs';
import {DeliveryPointRemote} from '../domain/delivery-point.remote';

/**
 * Notifies that the user has selected a delivery point.
 * This is used to send the selected delivery point to the backend.
 */
@Injectable({
    providedIn: 'root',
})
export class SendDeliveryPointSelectionUseCase {
    constructor(
        private deliveryPointRemote: DeliveryPointRemote,
    ) {} 

    execute(deliveryPointCode: number, credentials?: Credentials) {
        return firstValueFrom(this.deliveryPointRemote.saveDeliveryPoint(deliveryPointCode, credentials));
    }
}
